import Teaching from "./Teaching";
export default Teaching;
